import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";
import React from "react";

export const CopyIcon = (props: SvgIconProps) => {
    const { viewBox = "0 0 19 19", ...rest } = props;
    return (
        <SvgIcon viewBox={viewBox} {...rest}>
            <g id="Layer_2" data-name="Layer 2">
                <g id="Layer_1-2" data-name="Layer 1">
                    <rect fill="none" width="19" height="19" />
                    <path d="M17.9,18H5.3V5.38H17.9ZM6.5,16.78H16.7V6.58H6.5Z" />
                    <polygon points="4.5 15.09 2.1 15.09 2.1 2.48 14.7 2.48 14.7 4.41 13.5 4.41 13.5 3.68 3.3 3.68 3.3 13.89 4.5 13.89 4.5 15.09" />
                    <rect x="11" y="8.85" width="1.2" height="4.5" />
                    <rect x="9.35" y="10.5" width="4.5" height="1.2" />
                </g>
            </g>
        </SvgIcon>
    );
};
